export default "__VITE_ASSET__Bv59n7tO__"